import { render, staticRenderFns } from "./IgA.vue?vue&type=template&id=0041ec5c&scoped=true&"
import script from "./IgA.vue?vue&type=script&lang=js&"
export * from "./IgA.vue?vue&type=script&lang=js&"
import style0 from "./IgA.vue?vue&type=style&index=0&id=0041ec5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0041ec5c",
  null
  
)

export default component.exports